import { Route as RootRoute } from "@/routes/root";
import { PampersRoute, Route as LandingRoute } from "@/routes/landing";
import { Route as LockRoute } from "@/routes/lock";
import {
  Route as CompleteRoute,
  DoubleOptinRoute as CompleteDoubleOptinRoute,
} from "@/routes/complete";
import { Route as DelayedRoute } from "@/routes/delayed";
import { Route as DoubleOptinRoute } from "@/routes/double-optin";
import { Route as DoubleOptinV2Route } from "@/routes/double-optin-v2";
import { Route as ErrorRoute } from "@/routes/error";
import { Route as ReviewRoute } from "@/routes/review";
import { Route as AlreadyDelayedRoute } from "@/routes/already-delayed";
import { Route as UnsubscribeRoute } from "@/routes/unsubscribe";
import { Route as AlreadyUnsubscribedRoute } from "@/routes/already-unsubscribed";
import { Route as PageRoute } from "@/routes/page";
import { ConfigRoute, ShareableRoute } from "@/routes/preview";

export const routeTree = RootRoute.addChildren([
  //Pages
  // /flow/page/$pageId
  PageRoute,

  PampersRoute,
  // landing pages
  // /flow/$encodedActivityId
  LandingRoute,
  // /flow/$encodedActivityId/lock
  LockRoute,
  // /flow/$encodedActivityId/complete
  // /flow/community/$encodedActivityId/complete
  CompleteRoute,
  // /flow/$encodedActivityId/error/$errorType(closed|claimed|out_of_stock)
  ErrorRoute,

  // Double Optin
  // /flow/double_optin/$encodedActivityId/$encodedConsentId
  DoubleOptinRoute,
  // Note: CompleteDoubleOptinRoute is the "complete" page for DoubleOptin and DoubleOptinV2
  // /flow/double_optin/$encodedActivityId/$encodedOrderConsentIds/complete
  CompleteDoubleOptinRoute,
  // /flow/double_optin/v2/$encodedActivityId
  DoubleOptinV2Route,

  //Reviews
  // /flow/review/$encodedActivityId/
  // /flow/review/$encodedActivityId/$step(0-9)
  // /flow/review/$encodedActivityId/reviewed
  ReviewRoute,

  // Previews
  //
  // /flow/$encodedActivityId/config_preview/$ -> redirects to ->
  // /flow/claim|review|double_optin|community/$encodedActivityId/config_preview/$
  // /flow/$encodedActivityId/preview -> redirects to ->
  // /flow/claim|review|double_optin|community/$encodedActivityId/shareable_preview/$
  ConfigRoute,
  ShareableRoute,

  // no-config
  // /flow/unsubscribe/$shortOrderId
  UnsubscribeRoute,
  // /flow/unsubscribe/$shortOrderId/unsubscribed
  AlreadyUnsubscribedRoute,

  // /flow/delayed/$encodedActivityId
  DelayedRoute,
  // /flow/delayed/$encodedActivityId/already-delayed
  AlreadyDelayedRoute,
]);
